import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import PropTypes from 'prop-types';

import { getEnvironment } from '../../utils/helpers';

const mutation = graphql`
  mutation AddSolicitationCommentMutation($input: AddSolicitationCommentInput!) {
    addSolicitationComment(input: $input) {
      isUpdated
      solicitation {
        state
        comments {
          edges {
            node {
              id
              content
              created
              contentEditedAt
              repliedTo {
                content
                created
                user {
                  fullName
                }
              }
              contractor {
                fullName
                representativeImageUrl
                freelancer {
                  user {
                    id
                  }
                }
              }
              createdByStaff {
                fullName
                representativeImageUrl
                user {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;

const AddSolicitationCommentMutation = (input, callback) => {
  const config = {
    mutation,
    variables: { input },
    onCompleted: response => {
      callback(response.addSolicitationComment);
    }
  };

  commitMutation(getEnvironment(), config);
};

export default AddSolicitationCommentMutation;

AddSolicitationCommentMutation.propTypes = {
  input: PropTypes.objectOf(
    PropTypes.shape({
      solicitationId: PropTypes.string.isRequired,
      contractorId: PropTypes.string,
      content: PropTypes.string.isRequired
    })
  )
};
